export type KeycardColor = 'red' | 'blue' | 'yellow' | 'green'

export type KeycardChangeCallback = (cards: KeycardColor[]) => void

export class KeycardInventory {
  private cards = new Set<KeycardColor>()
  private changeCallbacks: KeycardChangeCallback[] = []

  hasKeycard(color: KeycardColor): boolean {
    return this.cards.has(color)
  }

  addKeycard(color: KeycardColor): void {
    if (!this.cards.has(color)) {
      this.cards.add(color)
      this.notifyChange()
    }
  }

  get keycards(): KeycardColor[] {
    return Array.from(this.cards)
  }

  onChange(cb: KeycardChangeCallback): () => void {
    this.changeCallbacks.push(cb)
    return () => {
      this.changeCallbacks = this.changeCallbacks.filter((c) => c !== cb)
    }
  }

  private notifyChange() {
    const list = this.keycards
    for (let i = 0; i < this.changeCallbacks.length; i++) {
      this.changeCallbacks[i](list)
    }
  }
}
